/**
 * @desc 导出全部模板
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.LaborConditionsQuery,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/labour/allExport',
    data,
  });
}

export function mock(
  data: defs.LaborConditionsQuery,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/labour/allExport',
    data,
  });
}
